module.exports = __webpack_public_path__ + "portal-static/img/certificate.981fc90c.png";